import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import FJTextToImageRightPresetItem from '../view/FJTextToImageRightPresetItem';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import FJConfig from '../../../../config/FJConfig.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';

const FJTextToImagePresetItemContainer = ({ presetData }) => {
    const dispatch = useDispatch();

    const onClickUsePrompt = presetData => {
        if (FJConfig.appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            dispatch(FJActionAIVideoGenerator.onClickUsePromptAction(presetData));
            return;
        }
        dispatch(FJActionTextToImage.onClickUsePromptAction(presetData));
    };
    return <FJTextToImageRightPresetItem onClickUsePrompt={onClickUsePrompt} presetInfo={presetData} />;
};

FJTextToImagePresetItemContainer.propTypes = {
    presetData: PropTypes.object,
};

export default FJTextToImagePresetItemContainer;
